var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarifas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 87.3 107.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #28689d;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: -153.3,
    y: -107.5,
    width: 87.3,
    height: 107.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_514",
    className: "st1",
    d: "M71.6,64.9c-.9-.3-1.1-.7-1.1-1.6,0-15.9,0-31.8,0-47.7,0-4.3-2.8-7.1-7.1-7.1-3.1,0-6.2,0-9.2,0-.4,0-.9-.2-1.1-.6-.8-1.8-2.6-2.8-4.6-2.8-1.4,0-2.8,0-4.2,0-.8,0-1.6-.4-2-1.1-3.7-5.4-10.4-5.4-14.1,0-.4.7-1.1,1.1-1.9,1-1.4,0-2.9,0-4.3,0-1.9,0-3.7,1-4.5,2.7-.2.5-.6.7-1.1.7-3,0-6,0-9,0C2.8,8.4,0,11.2,0,15.7v72.8c0,4.5,2.8,7.2,7.3,7.2,12.6,0,25.3,0,37.9,0,.7,0,1.3.3,1.6.9,2.4,4.2,6.1,7.5,10.6,9.3,2,.7,4.1,1.3,6.3,1.6h4c.4-.2.9-.3,1.3-.3,11.9-1.8,20-13,18.1-24.8-1.3-8.4-7.3-15.2-15.5-17.5M20,10.4c0-1.5.7-2.1,2.1-2.1s2.9,0,4.3,0c1.7.1,3.4-.8,4.2-2.3,1.4-2.5,4.5-3.5,7.1-2.1.9.5,1.6,1.2,2.1,2.1.9,1.5,2.5,2.4,4.2,2.3,1.5,0,2.9,0,4.4,0,1-.1,1.9.6,2,1.6,0,.1,0,.3,0,.4,0,1,0,2,0,2.9,0,1.4-.7,2-2.1,2-4.4,0-8.7,0-13.1,0h-13c-1.7,0-2.3-.6-2.3-2.3,0-.8,0-1.7,0-2.5M43.9,83c-.4,2.9-.2,5.8.7,8.6.2.7.2,1-.7.9-12.3,0-24.7,0-37,0-1.9.1-3.6-1.3-3.7-3.3,0-.2,0-.4,0-.6,0-12.2,0-24.4,0-36.6V15.8c0-2.9,1.3-4.2,4.2-4.2s5.6,0,8.4,0c.8,0,1.1.2,1.1,1-.1,1,0,2,.5,2.9.7,1.7,2.4,2.8,4.3,2.8,9.1,0,18.1,0,27.2,0,2.8,0,4.8-2.2,4.8-5.1q0-1.6,1.6-1.6c2.7,0,5.5,0,8.2,0,1.9-.2,3.7,1.2,3.9,3.2,0,.2,0,.5,0,.7,0,15.9,0,31.8,0,47.6,0,.8-.2,1-1,1-11.3-.5-21,7.8-22.4,19M65.5,104.3c-10.3,0-18.6-8.3-18.6-18.6,0-10.3,8.3-18.6,18.6-18.6,10.3,0,18.6,8.3,18.6,18.6,0,10.3-8.3,18.6-18.6,18.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_515",
    className: "st1",
    d: "M38.8,85.9c-.4,0-.8,0-1.2,0-8.8,0-17.6,0-26.3,0-1.7,0-1.5.2-1.5-1.5,0-21.4,0-42.8,0-64.2q0-1.7,1.7-1.8c.9,0,1.6-.6,1.6-1.5s-.6-1.6-1.5-1.6c0,0,0,0-.1,0-.8,0-1.7,0-2.5,0-1.9,0-2.4.4-2.4,2.4v69c0,1.9.5,2.4,2.3,2.4h28.9c.4,0,.8,0,1.2-.1.7-.2,1.1-.9,1-1.7,0-.7-.6-1.3-1.3-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_516",
    className: "st1",
    d: "M58.7,18.3c.2,0,.5,0,.7,0,1-.2,1.2.3,1.2,1.2,0,12.8,0,25.6,0,38.4,0,.4,0,.8,0,1.2.1.8.9,1.4,1.7,1.3.6,0,1.1-.5,1.2-1.1,0-.4.1-.8.1-1.2,0-6.7,0-13.5,0-20.2v-20.8c0-.9-.3-1.7-1.3-1.8-1.3-.1-2.7-.1-4,0-.8,0-1.3.7-1.3,1.5,0,0,0,.1,0,.2,0,.8.7,1.4,1.4,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_517",
    className: "st1",
    d: "M40.5,75.8c-.3,0-.6,0-.9,0h-11c-3.9,0-7.8,0-11.6,0-.9,0-1.6.5-1.7,1.4,0,0,0,0,0,.1,0,.9.8,1.6,1.7,1.6,0,0,0,0,0,0,.2,0,.4,0,.6,0h22c.4,0,.8,0,1.2-.1.8-.3,1.3-1.1,1-1.9-.2-.6-.7-1-1.3-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_518",
    className: "st1",
    d: "M39.1,62c.8-.2,1.3-1.1,1-1.9,0-.2-.2-.4-.3-.5-.4-.5-1.1-.7-1.7-.6-3.5,0-6.9,0-10.4,0h-2.2c-2.9,0-5.8,0-8.7,0-.9,0-1.6.6-1.7,1.5,0,0,0,0,0,0,0,.9.7,1.6,1.6,1.6,0,0,0,0,0,0,.2,0,.3,0,.5,0h20.5c.4,0,.8,0,1.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_519",
    className: "st1",
    d: "M38.8,42.1c-.2,0-.4,0-.6,0h-21c-.3,0-.6,0-.9.1-.8.2-1.3,1.1-1,1.9.2.6.7,1,1.2,1.1.3,0,.7,0,1,0h19.9c.4,0,.8,0,1.3,0,.8,0,1.4-.6,1.4-1.4,0,0,0,0,0,0,0-.8-.5-1.5-1.3-1.6,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_520",
    className: "st1",
    d: "M44.9,25.3c-6.5,0-12.9,0-19.4,0-1.2,0-2,.6-2,1.5,0,1,.7,1.6,2,1.6,3.2,0,6.4,0,9.6,0s6.5,0,9.7,0c1.2,0,1.9-.6,1.9-1.6,0-1-.7-1.6-1.9-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_521",
    className: "st1",
    d: "M17.2,36.8c2.7,0,5.3,0,8,0s5.4,0,8.1,0c1.3,0,1.9-.6,1.9-1.6,0-1-.7-1.6-1.9-1.6-5.3,0-10.7,0-16,0-1.2,0-2,.6-2,1.5,0,1,.7,1.6,2,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_522",
    className: "st1",
    d: "M25.2,67.4c-2.7,0-5.4,0-8.2,0-.7,0-1.4.3-1.7.9-.5,1.1.3,2.2,1.8,2.2,5.3,0,10.7,0,16,0,1.3,0,2-.6,2-1.6,0-1-.7-1.5-2-1.5-2.7,0-5.3,0-8,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_523",
    className: "st1",
    d: "M33.2,53.6c1.3,0,1.9-.5,1.9-1.5s-.7-1.6-1.9-1.6c-1,0-2,0-2.9,0h-12.5c-.3,0-.7,0-1,0-.8,0-1.5.7-1.5,1.5,0,.9.7,1.6,1.5,1.6,0,0,0,0,0,0,2.8,0,5.5,0,8.3,0h0c2.7,0,5.4,0,8.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_524",
    className: "st1",
    d: "M52.1,62c.6,0,1.2,0,1.8,0,.8,0,1.5-.8,1.5-1.6,0-.8-.7-1.4-1.5-1.5-1.2,0-2.4,0-3.6,0-.8,0-1.4.6-1.4,1.4,0,0,0,0,0,.1,0,.8.5,1.5,1.3,1.6,0,0,0,0,.1,0,.6,0,1.2,0,1.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_525",
    className: "st1",
    d: "M50.3,36.8c.6,0,1.2,0,1.8,0s1.2,0,1.8,0c.8,0,1.4-.6,1.5-1.4,0,0,0,0,0,0,.1-.8-.4-1.5-1.2-1.6,0,0,0,0-.1,0-1.3,0-2.6,0-3.9,0-.8,0-1.3.7-1.3,1.5,0,0,0,.1,0,.2,0,.8.6,1.4,1.4,1.4,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_526",
    className: "st1",
    d: "M54.1,42.2c-1.3-.2-2.6-.2-4,0-.8,0-1.3.7-1.3,1.5,0,0,0,.1,0,.2,0,.8.6,1.4,1.4,1.4,0,0,0,0,0,0,.6,0,1.2,0,1.8,0h0c.6,0,1.3,0,1.9,0,.8,0,1.4-.7,1.4-1.4,0,0,0,0,0,0,.1-.8-.4-1.5-1.2-1.6,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_527",
    className: "st1",
    d: "M50.2,53.6c.6,0,1.3,0,1.9,0h0c.6,0,1.3,0,1.9,0,.8,0,1.4-.8,1.4-1.7,0-.7-.6-1.3-1.3-1.4-1.3-.1-2.6-.1-3.9,0-.8.2-1.4.9-1.2,1.8.1.6.6,1.1,1.3,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_528",
    className: "st1",
    d: "M68,84.1c-.4-.1-.9-.1-.9-.8,0-1.6,0-3.3,0-5.1.4.2.6.3.9.4.7.4,1.7.2,2.1-.6,0,0,0,0,0,0,.4-.7.1-1.7-.6-2.1,0,0,0,0-.1,0-.4-.3-.9-.5-1.4-.6-.7-.1-.9-.5-.9-1.1,0-.8-.5-1.6-1.4-1.7,0,0-.2,0-.2,0-.9,0-1.5.6-1.5,1.8,0,.6-.3,1.1-.9,1.2-2.5,1-3.9,3.7-3.4,6.4.4,1.9,1.8,2.9,3.4,3.7.3.2.8.2.8.8,0,2.1,0,4.2,0,6.3,0,.5-.3.5-.7.4-.6-.2-1.2-.5-1.8-.9-.7-.5-1.7-.3-2.2.5-.5.7-.3,1.7.5,2.2,0,0,0,0,0,0,1,.7,2.1,1.2,3.3,1.4.7,0,.8.4.8,1,0,1.1.7,1.8,1.6,1.8.9,0,1.6-.8,1.6-1.7,0,0,0-.1,0-.2,0-.8.3-1,1-1.3,3-1.2,4.6-4.4,4-7.5-.5-2-2-3.6-4-4.2M63.9,82.1c-1.5-.6-1.5-2.4,0-3.5v3.5ZM69,90.1c0,1.2-.8,2.2-1.9,2.8,0-1.8,0-3.4,0-5,0-.5.1-.7.7-.4.9.5,1.4,1.5,1.2,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_529",
    className: "st1",
    d: "M35.3,11.6c.8,0,1.5-.7,1.5-1.5,0-.3,0-.6,0-.8h0c0-.3,0-.6,0-.8,0-.9-.6-1.6-1.5-1.6-.9,0-1.6.6-1.6,1.5,0,0,0,0,0,.1,0,.6,0,1.2,0,1.8,0,.8.7,1.5,1.6,1.4,0,0,0,0,0,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarifas);
export default __webpack_public_path__ + "static/media/tarifas.16e5b950727615a37aa2fa0732967a56.svg";
export { ForwardRef as ReactComponent };